var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-right-table-1"},[_c('dv-border-box-6',[_c('div',{staticClass:"table-name",staticStyle:{"padding-top":"8px"}},[_c('img',{attrs:{"src":require("./img/icon7.png")}}),_vm._v("料站信息\n    ")]),_c('dv-scroll-board',{staticStyle:{"margin-top":"-10px"},attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }